require('../../modules/es6.object.set-prototype-of');
module.exports = require('../../modules/_core').Object.setPrototypeOf;


//////////////////
// WEBPACK FOOTER
// ./~/rmc-feedback/~/core-js/library/fn/object/set-prototype-of.js
// module id = 3425
// module chunks = 6